import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentScanLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.72047 1.87502H11.2404C11.8504 1.87502 12.4341 2.13401 12.8564 2.59259C12.8563 2.59251 12.8565 2.59268 12.8564 2.59259L15.8898 5.8838C16.2903 6.31871 16.5139 6.89713 16.5139 7.49967V9.99708C16.5139 10.3422 16.2453 10.6221 15.9139 10.6221C15.5825 10.6221 15.3139 10.3422 15.3139 9.99708V7.49967C15.3139 7.2201 15.2105 6.9519 15.0242 6.74951C15.0241 6.74944 15.0242 6.74957 15.0242 6.74951L11.9908 3.4583C11.795 3.24567 11.5239 3.12502 11.2404 3.12502H6.7171C5.41365 3.11984 4.3455 4.19988 4.31084 5.55583V9.99708C4.31084 10.3422 4.04222 10.6221 3.71084 10.6221C3.37947 10.6221 3.11084 10.3422 3.11084 9.99708V5.54797L3.11102 5.53306C3.15771 3.49369 4.76208 1.86791 6.72047 1.87502Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.6283 1.92773C11.9597 1.92773 12.2283 2.20756 12.2283 2.55273V4.96337C12.2278 5.7948 12.8741 6.47049 13.6723 6.4725H15.8636C16.195 6.4725 16.4636 6.75233 16.4636 7.0975C16.4636 7.44268 16.195 7.7225 15.8636 7.7225H13.6704C12.2101 7.71935 11.0275 6.48462 11.0283 4.96337C11.0283 4.9633 11.0283 4.96343 11.0283 4.96337V2.55273C11.0283 2.20756 11.2969 1.92773 11.6283 1.92773Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.14844 9.99609C2.14844 9.65093 2.41706 9.37109 2.74844 9.37109H16.8509C17.1822 9.37109 17.4509 9.65093 17.4509 9.99609C17.4509 10.3413 17.1822 10.6211 16.8509 10.6211H2.74844C2.41706 10.6211 2.14844 10.3413 2.14844 9.99609Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.70506 12.1035C4.03643 12.1035 4.30507 12.3833 4.30507 12.7285V14.3064L4.30495 14.3185C4.27945 15.6967 5.32486 16.8401 6.65499 16.8769H12.974C14.2865 16.8112 15.3206 15.6765 15.3144 14.3094V14.3064V12.7285C15.3144 12.3833 15.583 12.1035 15.9144 12.1035C16.2457 12.1035 16.5144 12.3833 16.5144 12.7285V14.3053C16.5228 16.3483 14.9747 18.0382 13.0135 18.1263C13.0048 18.1268 12.9962 18.1269 12.9876 18.1269H6.64744L6.63313 18.1268C4.64158 18.0773 3.07008 16.3666 3.10507 14.3007V12.7285C3.10507 12.3833 3.37369 12.1035 3.70506 12.1035Z",
			fill: "currentColor"
		})
	]
});
export default SvgDocumentScanLine;
